"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteById = void 0;
const getSiteById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("sites")
        .select("*")
        .eq("id", id)
        .single();
    return data;
};
exports.getSiteById = getSiteById;
